export const stateNote = {
  notes: [],
};

export const stateScrum = {
  scrumboard: [],
  todo: [],
  settings: {},
};

const generateShortId = function (length) {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    result += chars.charAt(randomIndex);
  }
  return result;
};

export const createNotes = function () {
  const today = new Date().toISOString();
  const noteTitle = document.getElementById('n-title').value;
  const noteDescription = document.getElementById('n-description').value;
  const noteTag = document.getElementById('n-tags').value;
  const shortId = generateShortId(5);

  const data = {
    id: shortId,
    title: noteTitle,
    description: noteDescription,
    tag: noteTag,
    date: today,
    favorited: 0,
  };

  stateNote.notes.push(data);

  return data;
};

export const editNotes = function (noteId, favorited) {
  const today = new Date().toISOString();
  const noteTitle = document.getElementById('n-title').value;
  const noteDescription = document.getElementById('n-description').value;
  const noteTag = document.getElementById('n-tags').value;

  const data = {
    id: noteId,
    title: noteTitle,
    description: noteDescription,
    tag: noteTag,
    date: today,
    favorited: favorited,
  };

  return data;
};

export const createTodos = function (quill) {
  const today = new Date().toISOString();
  const todoTitle = document.getElementById('task-text').value;
  // const todoDescription = quill.getText().trim();
  const todoDescription = quill.root.innerHTML;
  const todoPriority = document.getElementById('priority').value;
  const shortId = generateShortId(5);

  const data = {
    id: shortId,
    title: todoTitle,
    description: todoDescription,
    priority: todoPriority,
    important: 0,
    completed: 0,
    trash: 0,
    date: today,
  };

  return data;
};

export const editTodos = function (quill, options) {
  const today = new Date().toISOString();
  const todoTitle = document.getElementById('task-text').value;
  // const todoDescription = quill.getText().trim();
  const todoDescription = quill.root.innerHTML;

  const todoPriority = document.getElementById('priority').value;

  const data = {
    id: options.todoId,
    title: todoTitle,
    description: todoDescription,
    priority: todoPriority,
    important: options.important,
    completed: options.completed,
    trash: options.trash,
    date: today,
  };

  return data;
};

export const createScrumBoard = function (options, isEdit = false) {
  let today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth());
  const yyyy = today.getFullYear();

  // prettier-ignore
  const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

  today = dd + ' ' + monthNames[mm] + ', ' + yyyy;

  const taskTitle = document.getElementById('s-task').value;
  const taskText = document.getElementById('s-text').value;
  const progress = document.getElementById('s-progress').value;
  const shortId = generateShortId(5);

  const data = {
    id: isEdit ? options.id : shortId,
    title: taskTitle,
    description: taskText,
    tasksection: options.tasksection,
    order: options.order,
    progress: progress,
    date: today,
  };

  return data;
};

export const createNewList = function (isEdit = false, options = null, order) {
  let today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();

  today = `${mm}.${dd}.${yyyy}`;

  const listId = generateShortId(5);
  const listTitle = document.getElementById('s-list-name').value;
  const listTitleLower = listTitle.toLowerCase();
  const listTitleRemoveWhiteSpaces = listTitleLower.split(' ').join('_');
  const listSectionDataAttr = `s-${listTitleRemoveWhiteSpaces}-${listId}`;

  const data = {
    id: isEdit ? options.section : listSectionDataAttr,
    title: listTitle,
    order: isEdit ? options.order : order,
    date: today,
  };

  return data;
};

export const createEvent = function (isEdit = false, OldEventId) {
  const getModalCheckedRadioBtnEl = document.querySelector(
    'input[name="event-level"]:checked'
  );
  const getTitleValue = document.querySelector('#event-title').value;
  const setModalStartDateValue =
    document.querySelector('#event-start-date').value;
  const setModalEndDateValue = document.querySelector('#event-end-date').value;
  const setModalUrlValue = document.querySelector('#event-url').value;
  const getModalCheckedRadioBtnValue =
    getModalCheckedRadioBtnEl !== null ? getModalCheckedRadioBtnEl.value : '';
  const eventID = generateShortId(5);

  const data = {
    id: isEdit ? OldEventId : eventID,
    title: getTitleValue,
    start: setModalStartDateValue,
    end: setModalEndDateValue,
    url: setModalUrlValue,
    allDay: false,
    extendedProps: { calendar: getModalCheckedRadioBtnValue },
  };

  return data;
};
